import React from 'react';
import { Poppins } from 'src/common';
import { BaseCard } from '../../styled';
import { ScenarioSvg } from 'src/assets/dynamicSvg';

interface TileReviewProps {
  overdue: number;
}

export const TileReview: React.FC<TileReviewProps> = ({ overdue }) => {
  return (
    <BaseCard>
      <span className="c-title">Review</span>
      <span className="description">You should review your risk scenarios on a regular basis.</span>
      <div style={{ flex: 1 }} />
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <ScenarioSvg />
        <Poppins weight={600} color="gp1" px={26}>
          {overdue}{' '}
          <Poppins weight={500} color="prussianBlue" px={14}>
            overdue
          </Poppins>
        </Poppins>
      </div>
    </BaseCard>
  );
};
